import React, { useEffect, useState, useRef } from 'react'
import { useHistory } from "react-router-dom";
import TreeTrades from './TreeTrades';
import TreeSupplementary from './TreeSupplementary';
import { BASE_URL } from "../../../Constants/serverConfig";
import { OverlayTrigger, Tooltip, Button } from 'react-bootstrap';
import './index.css'
import axios from 'axios';
import Loader from '../../Loader/loader';
import { isMobile } from 'react-device-detect';
import InteractivePanel from '../InteractivePanel';
import { INCLUDES_DEFAULT } from '../../../Constants/includeConstants';
import { SUPPLEMENTARY_DEFAULT } from '../../../Constants/supplementaryConstants';
import Chatbot from '../Chatbot';
const DATA_TRADES = require('../../../Constants/dataSourceTotal.json');
const DATA_SUPPLEMENTARY = require('../../../Constants/supplementaryDefaultSA00.json');
function WorkFlowOrganism(props) {

    let initialProjectData = {
        name: props.data?.name ?? "",
        zip_code: props.data?.zip_code ?? "",
        work_type: props.data?.work_type ?? "",
        main_building_use: props.data?.main_building_use ?? "",
        gross_area: props.data?.gross_area ?? "",
        id: props.data?.id ?? "",
        uuid: props.data?.uuid ?? "",
        project_item_selection: []
    }

    const [showProjectWorkflow, setShowProjectWorkflow] = useState(false);
    const [showProjectWorkflowNotification, setShowProjectWorkflowNotification] = useState(false);

    const [showSupplementaryModal, setShowSupplementaryModal] = useState(false);
    const [showInteractiveModal, setShowInteractiveModal] = useState(false);
    const [showSupplementaryPopup, setShowSupplementaryPopup] = useState(false);
    const [typeDefault, setTypeDefault] = useState("");

    const [pathList, setPathList] = useState(props.pathFramework ?? []);
    const [supplementaryList, setSupplementaryList] = useState(props.pathSupplementary ?? []);
    const [pathSupplementaryList, setPathSupplementaryList] = useState([]);
    const [supplementaryArray, setSupplementaryArray] = useState([]);
    const [lastPath, setLastPath] = useState([]);
    const [lastItemName, setLastItemName] = useState("");
    const [currentDefaultCode, setCurrentDefaultCode] = useState("");

    const [projectInformation, setProjectInformation] = useState(initialProjectData)

    const [workflow, setWorkflow] = useState((JSON.parse(JSON.stringify(DATA_TRADES))));
    const [supplementary, setSupplementary] = useState([]);

    const [showLoader, setShowLoader] = useState(false);

    const [loading, setLoading] = useState(true);
    const [showTooltip, setShowTooltip] = useState(true);
    const [notification, setNotification] = useState({ show: false, message: '' });
    const targetRefTool = React.useRef(null);


    const targetRef = useRef(null);
    const { subscription } = props;
    let history = useHistory();


    useEffect(() => {
        if (notification.show) {
            const timer = setTimeout(() => {
                setNotification({ show: false, message: "" });
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [notification.show])

    useEffect(() => {

        /**Inicializa el arbol base */
        setWorkflow(JSON.parse(JSON.stringify(DATA_TRADES)));

        /**Si es plan sin registro, valida lo guardado en cookies */
        if (subscription.plan === 'no-plan') {
            let project = JSON.parse(sessionStorage.getItem('workflow_project'));
            setProjectInformation(project);
            setPathList(JSON.parse(project.project_item_selection));
            setWorkflow(checkedItemTree(JSON.parse(project.project_item_selection)));

        }

        /**Actualizar el array de supplementary */

        let auxSupplementaryArray = [];
        supplementaryList.map(el => {
            auxSupplementaryArray.push({
                path: el.parent_path,
                list: JSON.parse(el.supplementary_path)
            });
        })
        setSupplementaryArray(auxSupplementaryArray);

        if (!props.isChildren) {
            history.push(`/workflow?s_id=${props.uuid}&check=true`)
            setProjectInformation(prevState => ({
                ...prevState,
                uuid: props.uuid
            }));
        }
        setShowProjectWorkflow(true);


        /** oculta el tooltip de ayuda flotante pasado 10 segundos*/
        const timer = setTimeout(() => {
            setShowTooltip(false);
        }, 10000);

        const timerLoading = setTimeout(() => {
            setLoading(false);
        }, 5000);

        return () => { clearTimeout(timer); clearTimeout(timerLoading); } // Limpia el temporizador si el componente se desmonta




    }, []);



    useEffect(() => {
        if (workflow && workflow.length) {
            props.loaderWorkflow(false);
        }
    }, [workflow]);


    useEffect(() => {
        if (showSupplementaryModal) {
            let data = JSON.parse(JSON.stringify(DATA_SUPPLEMENTARY));
            setSupplementary(data);
        } else {
            setSupplementary([]);
        }
    }, [showSupplementaryModal])

    useEffect(() => {
        if (supplementary.length) {
            setSupplementary(checkedItemSupplementaryTree(pathSupplementaryList));
        }
    }, [supplementary])


    useEffect(() => {
        if (showProjectWorkflow) { editWorkflow() }
    }, [showProjectWorkflow])

    useEffect(() => {

        /** detectar que archivo tomar para exponer en el modal de include/supplementary */
        const files = typeDefault === 'inc' ? INCLUDES_DEFAULT : typeDefault === 'sup' ? SUPPLEMENTARY_DEFAULT : {};
        const targetValues = currentDefaultCode;


        let DATA_IMPORT;

        if (currentDefaultCode && typeDefault && files && showSupplementaryModal) {

            const matchedFiles = files.filter(file =>
                targetValues && targetValues.some(value => file.match(new RegExp(`${value}(?!\\d)`)))
            );

            if (typeDefault == 'inc' && matchedFiles.length) {
                DATA_IMPORT = require('../../../Constants/includeDefaultFiles/' + matchedFiles[0] + '.json');
            } else if (typeDefault == 'sup' && matchedFiles.length) {
                DATA_IMPORT = require('../../../Constants/supplementaryDefaultFiles/' + matchedFiles[0] + '.json');
            }
        }



        if (lastPath.length) {
            let path = JSON.stringify(lastPath[0].split("-").map(Number));
            let comparePath = JSON.stringify(lastPath);

            /**evitar duplicar el path */
            const pathExists = supplementaryArray.findIndex(pathObj => pathObj.path === JSON.stringify(lastPath));

            if (pathExists < 0) {
                // Si el path no existe, agregarlo al array 
                setSupplementaryArray([...supplementaryArray, { path: JSON.stringify(lastPath), list: [] }]);
            } else {
                setPathSupplementaryList(supplementaryArray?.[pathExists]?.list || []);
            }
            const foundSupplementaryPath = supplementaryList.find(item => item.parent_path === comparePath);
            if (foundSupplementaryPath) {

                let data = JSON.parse(JSON.stringify(DATA_IMPORT ?? {}));
                setSupplementary(data);
                setPathSupplementaryList(supplementaryArray?.[pathExists]?.list || JSON.parse(foundSupplementaryPath.supplementary_path));
            } else {
                /** MODIFICAR ENFOQUE */
                let data = JSON.parse(JSON.stringify(DATA_IMPORT ?? {}));
                setSupplementary(data);
            }

        }

    }, [lastPath])

    const handleSupplementaryModal = (type = "") => {

        setTypeDefault(type);
        setShowSupplementaryModal(!showSupplementaryModal);
        setShowSupplementaryPopup(!showSupplementaryPopup);
    }

    const scrollNotificationProject = () => {
        if (isMobile) {
            targetRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }

    const handleLastPath = (path, item, type = {}) => {

        setCurrentDefaultCode(type === 'inc' ? item.include : type === 'sup' ? item.supplementary : []);
        setLastItemName(item.name);
        setLastPath([path]);
    }

    const editWorkflow = () => {
        setWorkflow(checkedItemTree(pathList));
    }

    const checkedItemTree = (paths) => {
        for (const [index, path] of paths.entries()) {
            let auxDataTrade = { ...workflow[0].children };
            for (let i = 0; i < path.length; i++) {
                const pos = path[i];
                if ((i + 1) != path.length) {
                    auxDataTrade[pos].visible = true;
                }
                if (!auxDataTrade[pos]) {
                    auxDataTrade[pos] = { children: [] };
                }
                if (i === path.length - 1) {
                    auxDataTrade[pos].checked = true;
                } else {
                    auxDataTrade = auxDataTrade[pos].children;
                }
            }
        }
        return workflow;
    }

    const checkedItemSupplementaryTree = (paths) => {

        for (const [index, path] of paths.entries()) {
            let auxDataTrade = { ...supplementary[0].children };
            for (let i = 0; i < path.length; i++) {
                const pos = path[i];
                if ((i + 1) != path.length) {
                    auxDataTrade[pos].visible = true;
                }
                if (!auxDataTrade[pos]) {
                    auxDataTrade[pos] = { children: [] };
                }
                if (i === path.length - 1) {
                    auxDataTrade[pos].checked = true;
                } else {
                    auxDataTrade = auxDataTrade[pos].children;
                }
            }
        }
        return supplementary;
    }

    const saveGroup = (data, pathArray) => {
        if (pathArray) {
            setPathList(pathArray);
            setProjectInformation(prevState => ({
                ...prevState,
                project_item_selection: pathArray
            }));
        }
    }

    const saveSupplementaryGroup = (data, pathArray) => {
        console.log('saveSupplementaryGroup', pathArray);
        if (pathArray) {
            setPathSupplementaryList(pathArray);
        }
    }

    const saveSupplementaryList = () => {
        setSupplementaryArray((prevData) =>
            prevData.map((item) =>
                item.path === JSON.stringify(lastPath)
                    ? { ...item, list: pathSupplementaryList }
                    : item
            )
        );

        setShowSupplementaryPopup(!showSupplementaryPopup);
        setShowSupplementaryModal(!showSupplementaryModal);
        setNotification({ show: true, message: `WBS include/supplementary default was updated` })
    }

    const submitDownloadFramework = () => {
        setShowLoader(true)
        axios.post(`${BASE_URL}/project/report`,
            {
                framework_data: JSON.stringify(pathList),
                uuid: props.uuid

            })
            .then((response) => {

                if (response.status === 200) {
                    axios.get(BASE_URL + '/public/project/download-report/' + props.uuid, {
                        responseType: 'blob'// Configurar responseType como blob para manejar archivos binario
                    }).then(response => {

                        const url = window.URL.createObjectURL(new Blob([response.data]));

                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', props.uuid + '.xlsx');
                        document.body.appendChild(link);
                        link.click();
                        setShowLoader(false);
                    }).catch(err => {
                        console.log(err);
                    });
                }

            })
            .catch((error) => {
            });

    }

    const updateAllFramework = () => {
        if (props.isChildren) {
            let auxProject = projectInformation;
            auxProject.project_item_selection = JSON.stringify(pathList);
            if (subscription.plan === 'no-plan') {
                sessionStorage.setItem('workflow_project', JSON.stringify(auxProject));
                return;
            }
            let bodyData = {
                project_data: auxProject,
                project_item_selection: pathList,
                project_supplementary_path: pathSupplementaryList,
                project_parent_supplementary_path: lastPath,
                project_supplementary_array: supplementaryArray
            }

            props.editProject(projectInformation.id, bodyData);
            setNotification({ show: true, message: `WBS was updated` })
        } else {
            setShowProjectWorkflow(false)
        }
    }

    const handleSupplementary = (item, checked) => {

        let path = item.split("-").map(Number);
        setSupplementary(checkedItemSupplementaryTree([path]));
    }

    const closeInteractiveModal = () => {
        setShowInteractiveModal(false);
    }

    const saveInteractiveModal = () => {
        setShowInteractiveModal(false);
    }

    const downloadInteractiveModal = () => {
        setShowInteractiveModal(false);
    }

    if (loading) {
        return <div className="mt-5">Loading WBS tree...</div>
    }


    return (

        <div className={'workflow-container-organic ' + (props.isChildren ? 'children' : '')}>
            {/* <Loader text="Loading..." open={showLoader} /> */}
            {notification.show && <div className="alert alert-success">{notification.message}</div>}
            <div className={`modal small-popup ` + (showInteractiveModal ? 'is-active' : '')}>
                <div className="modal-background" />
                <div className={"modal-card"}>
                    <section className={"modal-card-body-interactive"}>
                        {(workflow && workflow.length) &&
                            <InteractivePanel propsData={workflow[0]} close={closeInteractiveModal} save={saveInteractiveModal} download={downloadInteractiveModal} type={'show'} format={'wbs'} />
                        }
                    </section>
                </div>
            </div>


            <div className={`modal small-popup ` + (showSupplementaryPopup ? 'is-active' : '')}>
                <div className="modal-background" />
                <div className={"modal-card"}>
                    <section className={"modal-card-body"}>
                        {(supplementary && supplementary.length) ?
                            <TreeSupplementary
                                data={[supplementary[0]]}
                                handleSupplementary={handleSupplementary}
                                pathArray={pathSupplementaryList}
                                saveGroup={saveSupplementaryGroup}
                            />
                            : <></>
                        }

                    </section>
                    <div className='d-flex flex-column flex-md-row justify-content-end container-button-group bg-light py-2'>
                        <button className="btn btn-primary mr-2" onClick={() => saveSupplementaryList()}>Save</button>
                        <button className="btn btn-secondary mr-2" onClick={() => { setShowSupplementaryPopup(!showSupplementaryPopup); setShowSupplementaryModal(!showSupplementaryModal) }}>Close</button>
                    </div>
                </div>
            </div>


            {/* ... (resto del código superior) ... */}

            <div className={'workflow-body ' + (props.isChildren ? 'children' : '')}>
                <div className='workflow-details'>
                    {(workflow && showProjectWorkflow) &&
                        // 1. Añadimos la clase 'row' aquí para que los hijos se comporten como columnas
                        <div className='cont-workflow-organic w-100 row'>

                            {/* 2. Esta es tu div del árbol, ahora es la columna izquierda (8 de 12) */}
                            <div className='cont-workflow-organic-tree col-md-8'>
                                <div ref={targetRef} className={'node-notification-organic ' + (showProjectWorkflowNotification ? 'active' : 'inactive')}>
                                    <div>
                                        <p>{lastItemName} may include a supplementary default <span>SUP</span> and / or Include Default <span>INC</span>.  Click the icons to select it</p>
                                    </div>
                                </div>

                                <form className='workflow-details-form-organic'>
                                    <TreeTrades
                                        data={[workflow[0]]}
                                        saveGroup={saveGroup}
                                        pathArray={pathList}
                                        handleLastPath={handleLastPath}
                                        type={'SCHEMATIC'}
                                        paidMembership={props.isChildren ? true : false}
                                        setShowProjectWorkflowNotification={setShowProjectWorkflowNotification}
                                        showSupplementaryModal={handleSupplementaryModal}
                                        scrollNotificationProject={scrollNotificationProject}
                                    ></TreeTrades>
                                </form>
                            </div>

                            {/* 3. Este es tu div de la derecha, ahora es la columna derecha (4 de 12) */}
                            <div className='workflow-details-form-right-organic bg-light col-md-4'>
                                <div className='d-flex flex-column justify-content-center align-items-center w-100 '>
                                    {props.isChildren &&
                                        <>
                                            {/* --- INICIO: Layout de 2 columnas para desktop (del paso anterior) --- */}
                                            <div className='d-none d-md-flex flex-md-column'>

                                                {/* Columna 1: Texto */}
                                                <div className=''>
                                                    <h6 style={{ color: 'gray', fontSize: '14px', margin: 0 }} >Select all that apply and export excel to your favorite management tool</h6>
                                                </div>

                                                {/* Columna 2: Botones */}
                                                <div className='mt-3'>
                                                    <div className='d-flex flex-column w-100 justify-content-end'>
                                                        <span className="mt-1" style={{ color: '#666', fontSize: '14px', margin: 0, cursor: 'pointer' }} onClick={() => { updateAllFramework() }}><i className="bi bi-floppy2"></i> Save Changes</span>
                                                        <span className="mt-3" style={{ color: '#666', fontSize: '14px', margin: 0, cursor: 'pointer' }} onClick={() => {  setShowInteractiveModal(workflow.length ? false : true) }}><i className="bi bi-list-columns-reverse"></i> Table Of Content</span>
                                                        <span className="mt-3" style={{ color: '#666', fontSize: '14px', margin: 0, cursor: 'pointer' }} onClick={() => { submitDownloadFramework() }}><i className="bi bi-download"></i> Download WBS</span>

                                                        {/* <div className='container-button-group'>
                                                            <button className='btn btn-primary' style={{ width: 'auto' }} onClick={() => { updateAllFramework() }}>Save Changes</button>
                                                        </div>
                                                        <div className='d-flex flex-column container-button-group'>
                                                            {props.token &&
                                                                <button className='d-none d-md-block btn btn-secondary' style={{ width: 'auto' }} onClick={() => { setShowInteractiveModal(true) }} disabled={workflow.length ? false : true}>Table Of Content</button>
                                                            }
                                                            <button className='btn btn-secondary' style={{ width: 'auto' }} onClick={() => { submitDownloadFramework() }}>Download WBS</button>
                                                        </div> */}

                                                    </div>
                                                </div>
                                            </div>
                                            {/* --- FIN: Layout de 2 columnas para desktop --- */}


                                            {/* El layout de móvil no se modifica y se mantiene oculto en desktop */}
                                            <div className='d-flex d-md-none flex-row w-100 justify-content-between mt-2'
                                                style={{
                                                    position: "fixed",
                                                    bottom: 0,
                                                    left: 0,
                                                    width: "100%",
                                                    backgroundColor: "#f8f9fa",
                                                    padding: "0px",
                                                    display: "flex",
                                                    justifyContent: "space-around",
                                                    boxShadow: "0 -2px 5px rgba(0,0,0,0.1)",
                                                }}
                                            >
                                                <OverlayTrigger
                                                    placement="top"
                                                    show={showTooltip}
                                                    target={targetRefTool.current}
                                                    overlay={
                                                        <Tooltip id="tooltip-top" className='tooltip-workflow'>
                                                            Select all that apply and export excel to your favorite management tool.{' '}
                                                            <Button
                                                                variant="link"
                                                                className="text-light p-0 btn-tooltip-framework"
                                                                onClick={() => setShowTooltip(false)}
                                                            >
                                                                <strong>x</strong>
                                                            </Button>
                                                        </Tooltip>
                                                    }
                                                >
                                                    <div className='d-flex d-md-none flex-row w-100 justify-content-between ' ref={targetRef}>
                                                        <button className='btn btn-primary' style={{ width: '100%', height: '5vh', borderRadius: '0px' }} onClick={() => { subscription.plan === 'no-plan' ? props?.handleShowSubscriptionsWall() : updateAllFramework() }}>Save Changes</button>

                                                        <button className='btn btn-primary'
                                                            style={{ width: '100%', height: '5vh', borderRadius: '0px', backgroundColor: '#ffc107', borderColor: '#ffc107', color: 'black' }}
                                                            onClick={() => { submitDownloadFramework() }}>Download WBS</button>
                                                    </div>
                                                </OverlayTrigger>
                                            </div>
                                        </>
                                    }
                                </div>

                            </div>
                        </div>
                    }
                </div>

            </div>

            {/* ... (resto del código inferior) ... */}

        </div >
    )
}

export default WorkFlowOrganism